// dragStore.ts
let dragPayloadMap: Record<string, any> = {};

function stashDragPayload(id: string, data: any) {
  dragPayloadMap[id] = data;
}

function getDragPayload(id: string) {
  return dragPayloadMap[id];
}

function clearDragPayload(id: string) {
  delete dragPayloadMap[id];
}

export {
  stashDragPayload,
  getDragPayload,
  clearDragPayload,
}
